import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { School, Users, UserCog, Shield } from "lucide-react";
import { handleGet } from "../../controllers/controller.all";

export default function SuperDashboard() {
    const user = useSelector((state) => state.userReducer?.user);
    const token = user?.access_token || "";

    const [stats, setStats] = useState({
        total_ecoles: "--",
        total_eleves: "--",
        total_profs: "--",
        total_admins: "--"
    });

    useEffect(() => {
        const fetchStats = async () => {
            if (!token) return;
            await handleGet("/user/superadmin/stats", (res) => {
                if (res) {
                    setStats({
                        total_ecoles: res.total_ecoles || 0,
                        total_eleves: res.total_eleves || 0,
                        total_profs: res.total_profs || 0,
                        total_admins: res.total_admins || 0
                    });
                }
            }, token);
        };
        fetchStats();
    }, [token]);

    const cards = [
        { title: "Écoles", value: stats.total_ecoles, icon: School, color: "text-indigo-600", bg: "bg-indigo-50" },
        { title: "Élèves", value: stats.total_eleves, icon: Users, color: "text-blue-600", bg: "bg-blue-50" },
        { title: "Professeurs", value: stats.total_profs, icon: UserCog, color: "text-orange-600", bg: "bg-orange-50" },
        { title: "Admins", value: stats.total_admins, icon: Shield, color: "text-emerald-600", bg: "bg-emerald-50" },
    ];

    return (
        <div className="flex flex-col gap-6">
            <header className="flex flex-col gap-1">
                <h1 className="text-3xl font-bold tracking-tight text-gray-900">Vue d'ensemble Super Admin</h1>
                <p className="text-gray-500">Bienvenue, {user?.prenom || 'Super Admin'} ! Voici les statistiques globales du réseau.</p>
            </header>

            <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4 lg:gap-6">
                {cards.map((card, i) => {
                    const Icon = card.icon;
                    return (
                        <div key={i} className="rounded-xl border border-gray-200 bg-white p-4 sm:p-5 lg:p-6 shadow-sm flex items-start justify-between gap-3 sm:gap-4 min-w-0">
                            <div className="min-w-0">
                                <dt className="truncate text-xs sm:text-sm font-medium text-gray-500">{card.title}</dt>
                                <dd className="mt-1 sm:mt-2 text-2xl sm:text-3xl font-semibold tracking-tight text-gray-900 truncate">{card.value}</dd>
                            </div>
                            <div className={`p-2.5 lg:p-3 rounded-xl flex-shrink-0 ${card.bg} ${card.color}`}>
                                <Icon className="w-5 h-5 lg:w-6 lg:h-6" />
                            </div>
                        </div>
                    );
                })}
            </div>

            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4 sm:p-6">
                <h2 className="text-lg font-bold text-gray-900 mb-4">Raccourcis Rapides</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    <a href="/super-admin/ecoles" className="p-4 border border-gray-100 rounded-lg hover:border-indigo-100 hover:bg-indigo-50 hover:shadow-sm transition-all group flex flex-col gap-2 cursor-pointer">
                        <School className="w-6 h-6 text-indigo-500" />
                        <span className="font-semibold text-gray-900 group-hover:text-indigo-700">Gérer les Écoles</span>
                        <span className="text-sm text-gray-500">Ajouter ou modifier des établissements</span>
                    </a>
                    <a href="/super-admin/admins" className="p-4 border border-gray-100 rounded-lg hover:border-emerald-100 hover:bg-emerald-50 hover:shadow-sm transition-all group flex flex-col gap-2 cursor-pointer">
                        <Shield className="w-6 h-6 text-emerald-500" />
                        <span className="font-semibold text-gray-900 group-hover:text-emerald-700">Gérer les Administrateurs</span>
                        <span className="text-sm text-gray-500">Créer des comptes admin pour les écoles</span>
                    </a>
                    <a href="/super-admin/notifications" className="p-4 border border-gray-100 rounded-lg hover:border-blue-100 hover:bg-blue-50 hover:shadow-sm transition-all group flex flex-col gap-2 cursor-pointer">
                        <Users className="w-6 h-6 text-blue-500" />
                        <span className="font-semibold text-gray-900 group-hover:text-blue-700">Notifications Globales</span>
                        <span className="text-sm text-gray-500">Envoyer des annonces à tous les admins</span>
                    </a>
                </div>
            </div>
        </div>
    );
}
